export default "__VITE_ASSET__Bw$1yJA4__"